export const TOP_TAB_BAR_HEIGHT = 48;
export const TAB_SCREEN_PAGINATION_BTN_HEIGHT = 44;
